import PageTitleDescription from './PageTitleDescription';

export default PageTitleDescription;
